export default function Footer() {
  return (
    <footer className="relative bg-gradient-to-br from-slate-800 to-slate-900 text-white py-16">
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://public.readdy.ai/ai/img_res/26842d97a9cec49b6616071a8d8d5f89.jpg" 
          alt="" 
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <img 
            src="https://public.readdy.ai/ai/img_res/33d899ef-9241-4cf3-ade8-29e9cb8b45e8.png" 
            alt="ClearPath Consulting" 
            className="h-48 mx-auto mb-8"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
              <i className="ri-map-pin-line text-2xl"></i>
            </div>
            <p className="text-sm text-white/90 mb-2">Dallas, TX | Calgary, AB | London, UK | Bangalore, IN</p>
            <h6 className="font-semibold text-sm">Our Locations</h6>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
              <i className="ri-mail-line text-2xl"></i>
            </div>
            <p className="text-sm text-white/90 mb-2">info@clearpathconsulting-global.com</p>
            <h6 className="font-semibold text-sm">Email Us</h6>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
              <i className="ri-phone-line text-2xl"></i>
            </div>
            <p className="text-sm text-white/90 mb-2">+1 (403) 903-5343</p>
            <h6 className="font-semibold text-sm">Give Us A Call</h6>
          </div>
        </div>

        <div className="text-center border-t border-white/20 pt-8">
          <p className="text-sm text-white/80 mb-4">Copyright © 2025 ClearPath Consulting Inc. All Rights Reserved.</p>
          <div className="flex justify-center space-x-4">
            <a 
              href="https://www.linkedin.com/company/clear-path-consulting-inc/?viewAsMember=true" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white hover:text-slate-900 transition-colors"
            >
              <i className="ri-linkedin-fill text-xl"></i>
            </a>
            <a 
              href="https://twitter.com/clearpathconsulting" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white hover:text-slate-900 transition-colors"
            >
              <i className="ri-twitter-x-line text-xl"></i>
            </a>
          </div>
          <div className="mt-6">
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-xs text-white/60 hover:text-white transition-colors"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
